import React from 'react'
import { useIsFocused } from 'expo-router'
import { View } from 'react-native'
import { TurnInCardsModal } from '../../../components/cards/TurnInCardsModal'
import { game } from '../../../preview/fixtures/cardBonusOnly'
import { buildActiveGameViewProps } from '../../../preview/buildActiveGameViewProps'
import type { GameState } from '../../../lib/gameState'

// Real bundled names from short to the longest outside Forbidden City, plus a
// wild card with no name: every card's art and title must line up.
const NAMES = ['Peru', 'Muhlig-Hofmann', 'Massachusetts', 'Pole of Inaccessibility']
const TYPES = ['infantry', 'cavalry', 'artillery', 'infantry'] as const

const previewState = buildActiveGameViewProps(game).gameState
const state: GameState = {
  ...previewState,
  mustTurnInCards: false,
  map: {
    ...previewState.map,
    territories: previewState.map.territories.map((territory, index) =>
      index < NAMES.length ? { ...territory, name: NAMES[index]! } : territory),
  },
  cards: { '1': [
    ...NAMES.map((_, index) => ({ id: `name-${index}`, type: TYPES[index]!, territoryId: previewState.map.territories[index]?.id })),
    { id: 'name-wild', type: 'wild' as const },
  ] },
}

export default function CardNamesPreview() {
  const focused = useIsFocused()
  return (
    <View className="flex-1 bg-canvas">
      <TurnInCardsModal visible={focused} onClose={() => {}}
        gameId="preview-card-names" state={state} myPlayerId="1" canTurnInCards={false}
        tutorialEnabled={false} onTutorialEnabledChange={() => {}} />
    </View>
  )
}
